var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockArrowBlue = function SvgClockArrowBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clockArrowBlue_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m71.626 67.61-3.977 3.976-16.242-16.242a8 8 0 0 1-3.367.738c-3.468 0-6.432-2.196-7.577-5.27H29.067v-5.624h11.396c1.145-3.074 4.109-5.27 7.577-5.27 4.456 0 8.082 3.626 8.082 8.082a8 8 0 0 1-.738 3.368z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.04 45.543a2.46 2.46 0 0 0-2.457 2.458 2.46 2.46 0 0 0 2.458 2.458A2.46 2.46 0 0 0 50.499 48a2.46 2.46 0 0 0-2.459-2.458"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#clockArrowBlue_svg__b)",
    d: "M89.318 45.187a41.1 41.1 0 0 0-3.74-14.632L65.014 27.05l6.272-6.272a35.47 35.47 0 0 0-20.433-8.461v5.537h-5.624v-5.538c-17.5 1.367-31.504 15.372-32.87 32.871h5.537v5.625h-5.538c1.367 17.499 15.372 31.504 32.871 32.87v-5.537h5.624v5.538c17.5-1.367 31.505-15.372 32.871-32.871h-5.537v-5.625zM71.626 67.608l-3.977 3.977-16.241-16.241a8 8 0 0 1-3.368.738c-3.468 0-6.432-2.196-7.577-5.27H29.067v-5.625h11.396c1.145-3.074 4.11-5.27 7.577-5.27 4.457 0 8.083 3.626 8.083 8.082a8 8 0 0 1-.738 3.368z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4173C3",
    d: "M95.96 50.812h-6.596c-.666 10.005-4.881 19.318-12.037 26.475-7.823 7.822-18.224 12.13-29.287 12.13s-21.464-4.308-29.286-12.13S6.623 59.063 6.623 48s4.308-21.464 12.13-29.286S36.978 6.583 48.04 6.583s21.464 4.308 29.287 12.13l1.988 1.989-2.633 2.632 11.296 1.926-1.925-11.296-2.085 2.085-1.988-1.989C72.913 4.993 60.86 0 48.04 0 35.22 0 23.165 4.993 14.1 14.059 5.032 23.125.04 35.179.04 48S5.033 72.875 14.1 81.941C23.164 91.007 35.218 96 48.04 96c12.822 0 24.875-4.993 33.941-14.059 8.4-8.4 13.304-19.365 13.979-31.129"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "clockArrowBlue_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(135.156 38.232 25.7)scale(91.6534 85.2316)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clockArrowBlue_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h96v96H0z"
  })))));
};
export default SvgClockArrowBlue;